import { motion } from 'motion/react';
import { useAudio } from '../context/AudioContext';
import { cn } from '../lib/cn';

/**
 * Tiny toggle: 4 vertical bars that animate when audio is on, freeze when off.
 * Lives in the navbar next to LanguageSwitcher.
 */
export function AudioToggle() {
  const { enabled, toggle } = useAudio();

  return (
    <button
      type="button"
      onClick={toggle}
      aria-pressed={enabled}
      aria-label={enabled ? 'Audio on' : 'Audio off'}
      title={enabled ? 'Suono attivo' : 'Suono spento'}
      className="inline-flex items-end gap-[3px] h-5 px-1.5 py-1 -m-1.5"
      data-magnetic="true"
    >
      {[0, 1, 2, 3].map((i) => (
        <motion.span
          key={i}
          className={cn('w-[2px] bg-current rounded-full', enabled ? 'opacity-100' : 'opacity-40')}
          animate={
            enabled
              ? {
                  height: [
                    6 + (i % 2) * 3,
                    12 + ((i + 1) % 3) * 3,
                    8 + (i % 2) * 4,
                    14 - (i % 2) * 3,
                  ],
                }
              : { height: i === 1 || i === 2 ? 12 : 6 }
          }
          transition={
            enabled
              ? {
                  duration: 0.9 + i * 0.13,
                  repeat: Infinity,
                  repeatType: 'mirror',
                  ease: 'easeInOut',
                }
              : { duration: 0.3 }
          }
        />
      ))}
    </button>
  );
}
